import classNames from "classnames";
import React, { ReactNode, useEffect, useState } from "react";
import styles from "./Layout.module.scss";
import Sidebar from "../Sidebar/Sidebar";
import Topbar from "../Topbar/Topbar";
import Footer from "../Footer/Footer";

type Props = { children: ReactNode };

const DESKTOP_QUERY = "(min-width: 1024px)";

function Layout({ children }: Props) {
  const prefersDesktop =
    typeof window === "undefined"
      ? true
      : window.matchMedia(DESKTOP_QUERY).matches;
  const [sidebarVisible, setSidebarVisible] = useState(prefersDesktop);

  useEffect(() => {
    const media = window.matchMedia(DESKTOP_QUERY);
    const handleChange = (event: MediaQueryListEvent) => {
      if (event.matches) {
        setSidebarVisible(true);
      }
    };
    media.addEventListener("change", handleChange);
    return () => media.removeEventListener("change", handleChange);
  }, []);

  const shellClassName = classNames(styles.shell, {
    [styles.noSidebar]: !sidebarVisible,
  });

  const handleToggleSidebar = () => {
    setSidebarVisible((previous) => !previous);
  };

  const handleBackdropClick = () => {
    if (typeof window === "undefined") {
      return;
    }
    if (window.matchMedia(DESKTOP_QUERY).matches) {
      return;
    }
    setSidebarVisible(false);
  };

  return (
    <div className={shellClassName}>
      <div className={styles.sidebarPane} data-open={sidebarVisible}>
        <Sidebar />
      </div>
      <div
        className={styles.sidebarBackdrop}
        data-open={sidebarVisible}
        aria-hidden="true"
        onClick={handleBackdropClick}
      />
      <div className={styles.main}>
        <Topbar
          sidebarVisible={sidebarVisible}
          onToggleSidebar={handleToggleSidebar}
        />
        <div className={styles.content}>{children}</div>
        <Footer />
      </div>
    </div>
  );
}

export default Layout;
